import React, { Component, Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { connect } from "react-redux";
import moment from "moment";
import { Redirect } from "react-router-dom";
import { breadcrumbsLink } from "../../FormerCustomer/actions"
import { handleModalState } from "common-components/Modal/actions/handleModalState";
import {
  cancelDownload,
  fetchPageContent,
  checkIfMDNisSMSCapable,
  clearErrors,
  // resendPasswordBegin
} from "../actions";
import { resendPasswordBegin } from "../actions/resendPassword"
import { fetchDownloadAndDeleteLanding } from "../../LoggedInLanding/actions";
import { setA11yContent } from "../../NavigationHelper/actions";
import { ENDPOINTS } from "utils/endpoints";
import { media } from "utils/style";
import { formatPhoneNumber } from "utils/formatPhoneNumber";
import { checkNestedObject } from "utils/checkNestedObject";
import { cleanDateFormat } from "utils/cleanDateFormat";
import { setBaseURLForNonSecure } from "../../../../../Services/API";
import { setBreadcrumbList } from "common-components/BreadCrumbs/actions";
import { checkAMLob } from "utils/checkAMLob";
import { isUnregistered } from "utils/isUnregistered";

import Container from "common-components/Container";
import DownloadModal from "./DownloadModal/DownloadModal";
import RectangleLoader from "common-components/RectangleLoader/RectangleLoader";
import Alert from "common-components/Alert";
import CancelRequestModal from "./CancelRequestModal/CancelRequestModal";
import DeleteFileModal from "./DeleteFileModal";
import DownloadReady from "./DownloadReady";
import DownloadPending from "./DownloadPending";
import GuestDeleteFileSuccess from "../../GuestFlow/GuestDeleteFileSuccess";
import { MaximumPasswordsReached } from "../../ResendPassword";

class DownloadStatus extends Component {
  state = {
    showCancelModal: false,
    showDeleteFileModal: false,
    needsAffidavit: false,
    loading: true,
    fromTokenizedLink: false,
    showGuestCancelSuccessModal: false,
    isUnregistered: false,
    showMaxPasswordModal: false
  };

  componentDidMount() {
    const updatedPageTitle = () => {
      const { pageContent, setA11yContent, downloadReady } = this.props;

      if (!isUnregistered()) {
        if (
          checkNestedObject(pageContent, "breadCrumbs", "downloadFile") &&
          checkNestedObject(pageContent, "breadCrumbs", "requestStatus")
        ) {
          const {
            breadCrumbs: { landingPage, downloadFile, requestStatus }
          } = pageContent;

          this.props.setBreadcrumbList([
            { label: landingPage, path: "/privacy/secure/your-data" },
            {
              label: downloadReady ? downloadFile : requestStatus,
              path: "/privacy/secure/download-status"
            }
          ]);
        }
      }



      if (
        checkNestedObject(pageContent, "download_pending", "sc_pagetitle") &&
        checkNestedObject(pageContent, "download_complete", "sc_pagetitle")
      ) {
        const {
          download_pending: { sc_pagetitle: downloadPendingTitle },
          download_complete: { sc_pagetitle: downloadCompleteTitle }
        } = pageContent;

        setA11yContent("Download status", downloadReady ? downloadCompleteTitle : downloadPendingTitle);
      }
    };

    if (checkNestedObject(this.props.location.state, "showDownloadModal") && this.props.dateOfRequest) {
      this.props.handleModalState();
      updatedPageTitle();
      this.setState({ loading: false });
    } else {
      if (
        this.props.location.pathname === "/privacy/your-data/guest/download" ||
        this.props.location.pathname === "/privacy/your-data/guest-download/"
      ) {
        this.setState({ isUnregistered: true });
        this.setState({ fromTokenizedLink: true });

        setBaseURLForNonSecure();

        // this.props.fetchDownloadAndDeleteLanding().then(() => {

          let url =
            window.reactGlobals.ccpaFlow === "GUEST" || window.reactGlobals.ccpaFlow === "FORMER"
              ? ENDPOINTS.FETCH_GUEST_DOWNLOAD_STATUS_PAGES_NEW
              : ENDPOINTS.FETCH_IVR_PAGES;

          this.props.fetchPageContent(url).then(() => {
            this.setState({ loading: false });

            //BreadCrumbs for Former AND Guest
            if (window.reactGlobals.ccpaFlow === "GUEST" || window.reactGlobals.ccpaFlow === "FORMER") {
              const { pageContent, location } = this.props;
              if (pageContent) {
                if (checkNestedObject(pageContent, "download_complete", "sc_pagetitle")) {
                  const authTokenString = window.location.search;
                  let pathname;
                  if (location.state && location.state.page) {
                    pathname = "/privacy/your-data/guest-download" + authTokenString
                  }
                  this.props.setBreadcrumbList([
                    { label: pageContent.download_complete.genericList[0].list[1].jsonValue },
                    { label: pageContent.download_complete.genericList[0].list[0].jsonValue, path: pathname }
                  ]);
                }
              }
            }

            if (
              this.props.requestedChannel === "IVR" &&
              !this.props.consentedDate &&
              this.props.downloadReady
            ) {
              this.setState({ needsAffidavit: true });
            }
            updatedPageTitle();
          });
        this.props.fetchDownloadAndDeleteLanding();
      } else {
        let url = "";
        const { requestedChannel } = this.props;

        if (
          checkAMLob() === "vzt" ||
          checkAMLob() === "ott" ||
          checkAMLob() === "nico" ||
          checkAMLob() === "autoapp" ||
          checkAMLob() === "ip" ||
          checkAMLob() === "vils"
        ) {
          if (checkAMLob() === "vzt") {
            url = ENDPOINTS.FETCH_WIRELINE_STATUS_PAGES;
          } else if (checkAMLob() === "autoapp"){                      
            url = ENDPOINTS.FETCH_CVA_STATUS_PAGES;
          } else if (checkAMLob() === "ip"){   
            url = ENDPOINTS.FETCH_CVA_STATUS_PAGES;                   
          }else{
            url = ENDPOINTS.FETCH_OTT_STATUS_PAGES;
          }
        } else if (requestedChannel === "IVR") {
          url = ENDPOINTS.FETCH_IVR_PAGES;
        } else {
          url = ENDPOINTS.FETCH_DOWNLOAD_STATUS_PAGES;
        }

        this.props.fetchPageContent(url).then(() => {
          this.setState({ loading: false });

          if (requestedChannel === "IVR" && !this.props.consentedDate && this.props.downloadReady) {
            this.setState({ needsAffidavit: true });
          }
          updatedPageTitle();
        });
      }
    }
  }

  showConfirmationModal = type => {

    if (checkNestedObject(this.props.location, "state", "showDownloadModal")) {
      this.props.location.state.showDownloadModal = false;
    }

    this.props.handleModalState();
    this.props.clearErrors();

    if (type === "delete") {
      this.setState({ showDeleteFileModal: true });
    } else {
      this.setState({ showCancelModal: true });
    }
  };

  handleClick = type => {
    this.props.handleModalState(false);
    this.setState({ showCancelModal: false, showDeleteFileModal: false });

    this.props.cancelDownload(type).then(() => {
      if (!this.props.error) {
        if (this.state.isUnregistered) {
          this.props.handleModalState();
          this.setState({ showGuestCancelSuccessModal: true });
        } else {
          this.props.history.replace("/privacy/secure/your-data");
        }
      }
    });
  };

  componentDidUpdate(prevProps) {
    if (this.props.showModal !== prevProps.showModal && this.props.showModal === false) {
      this.setState(prevState => ({
        showCancelModal: false,
        showGuestCancelSuccessModal: false,
        showDeleteFileModal: false
      }));
    }
  }

  checkForCSRFTokenInfo = () => {
    const el = document.querySelector('meta[name="csrfToken"]');
    if (el && el.getAttribute("content")) {
      return el.getAttribute("content");
    }
    return "";
  };

  formatDate = date => {
    return moment(date)
      .format("MMM DD, YYYY")
      .toString();
  };

  renderCategoryList = () => {
    if (checkAMLob() === "vzw" || checkAMLob() === "vzt" || checkAMLob() === "ott" || checkAMLob() === "autoapp" || checkAMLob() === "ip") {
      return (
        <ul style={{margin: '10px 0 0 16px',listStyleType: 'disc'}}>
          {this.props.requestCategories.map(item => (
            <li key={item}>{item}</li>
          ))}
        </ul>
      );
    }
    return null;
  };

  handleDownloadFileClick = () => {
    const authTokenString = window.location.search;

    // if (
    //   this.props.requestedChannel === "IVR" ||
    //   (checkAMLob() === "ott" || checkAMLob() === "nico")
    // ) {
    //   const startMFAFlow = () => {
    //     this.props.history.push("/privacy/secure/multifactor-authentication-primer", {
    //       confirmAuth: true,
    //       nextRoute: "/privacy/secure/retrieval-password",
    //       showDownloadModal: true,
    //       resendPWFlow: true,
    //       requesPassword: true,
    //     });
    //   };

    //   startMFAFlow()
    //   // this.props.handleModalState();
    //   // this.props.location.state = {};
    //   // this.props.location.state.showDownloadModal = true;
    // } else
    if (
      window.reactGlobals.ccpaFlow === "GUEST" ||
      window.reactGlobals.ccpaFlow === "FORMER"){
      this.props.history.push({
        pathname: "/privacy/your-data/guest-download/" + authTokenString,
        state: {
          page: "email",
          authToken: authTokenString,
          loginEmailID: this.props.emailId
        }
      });
    }else if(window.reactGlobals.ccpaFlow === "IVR_UNREGISTERED") {
      this.props.checkIfMDNisSMSCapable(this.props.encryptedMtn).then(() => {
        if (!this.props.error) {
          const { mfaAllowed } = this.props.verifiedSecurePinDevice;
          if (mfaAllowed === false) {
            this.props.history.push("action-needed");
          } else {
            this.props.history.push("/privacy/secure/multifactor-authentication-primer", {
              confirmAuth: true,
              nextRoute: "/privacy/secure/retrieval-password",
              showDownloadModal: true,
              resendPWFlow: true,
              requesPassword: true,
            });
          }
        }
        });
    }else {
      const startMFAFlow = () => {
        this.props.history.push("/privacy/secure/multifactor-authentication-primer", {
          confirmAuth: true,
          nextRoute: "/privacy/secure/retrieval-password",
          showDownloadModal: true,
          resendPWFlow: true,//true
          requesPassword: true,
        });
      };

      
      if (this.props.requestedChannel === "IVR"){
        if(checkAMLob() === "vzw"){
          this.props.checkIfMDNisSMSCapable(this.props.encryptedMtn).then(() => {
            if (!this.props.error) {
              const { mfaAllowed } = this.props.verifiedSecurePinDevice;
              if (mfaAllowed === false) {
                this.props.history.push("action-needed");
              } else 
              {
                startMFAFlow();
              }
            }
          });
        }
        else if(checkAMLob() === "ott" || checkAMLob() === "autoapp" || checkAMLob() === "ip" || checkAMLob() === "nico" || checkAMLob() === "vzt" || checkAMLob() === "vils")
          {
          startMFAFlow();
        }
      } else if((checkAMLob() === "ott" || checkAMLob() === "autoapp" || checkAMLob() === "ip" || checkAMLob() === "nico" || checkAMLob() === "vzt" || checkAMLob() === "vils")
      ) {
          startMFAFlow(); 
      } else if (checkAMLob() === "vzw") {
        this.props.checkIfMDNisSMSCapable(this.props.encryptedMtn).then(() => {
          if (!this.props.error) {
            const { mfaAllowed } = this.props.verifiedSecurePinDevice;
            if (mfaAllowed === false) {
              this.props.history.push("action-needed");
            } else {
              startMFAFlow();
            }
          }
        });
      }
    }
  };

  checkNotificationMethod = () => {
    let notificationMethod = "";
    const { accountEmail, accountOttEmail, wlnMdn } = window.reactGlobals;
    const { mtnList } = this.props;

    if (checkAMLob() === "ott" && accountOttEmail) {
      notificationMethod = accountOttEmail;                     
    } else if (checkAMLob() === "vzt") {
      if (accountEmail && wlnMdn) {
        notificationMethod = `${accountEmail}, and ${formatPhoneNumber(wlnMdn)}`;
      } else if (accountEmail) {
        notificationMethod = accountEmail;
      } else {
        notificationMethod = formatPhoneNumber(wlnMdn);
      }
    } else {
      if (mtnList.length && accountEmail) {
        notificationMethod = `${accountEmail}, and ${formatPhoneNumber(mtnList[0])}`;
      } else if (mtnList.length) {
        notificationMethod = formatPhoneNumber(mtnList[0]);
      } else {
        notificationMethod = accountEmail;
      }
    }
    return notificationMethod;
  };

  checkPasswordFlow = () => {
    if (parseInt(this.props.noOfPwdNotificationRemaining) === 0) {
      return this.setState({ showMaxPasswordModal: true });
    }
    this.props.resendPasswordBegin(this.props.location.pathname);
  };

  getLabelFromDays = (days) => {
    switch (days) {
      case 30: return ": Last 30 days";
      case 90: return ": Last 3 months";
      case 180: return ": Last 6 months";
      case 365: return ": Last 12 months";
      default: return ": " + days + " days";
    }
  }

  handleRequestHistoryClick = () => {
    const queryString = window.location.search;
    let currentPageName = window.location.pathname + queryString;
    const route = "/privacy/your-data/request-history"
    let pageLink;
    pageLink = [
      { requestStatusPageName: currentPageName },
      { requestHistoryPageName: route },
      { isSelectBox: false },
    ]
    this.props.breadcrumbsLink(pageLink)
    this.props.history.push(route, {
      nextRoute: "/privacy/your-data/former-customer",
      PreviouspageName: currentPageName
    });

  }

  render() {
    if (this.props.loading || this.state.loading) {
      return <RectangleLoader />;
    }

    if (this.state.needsAffidavit) {
      return (
        <Redirect
          to={{
            pathname: "/privacy/your-data/guest/affidavit",
            state: { fromTokenizedLink: this.state.fromTokenizedLink }
          }}
        />
      );
    }

    if (!this.props.dateOfRequest && this.props.location.pathname === "/privacy/secure/download-status") {
      return <Redirect to="/privacy/secure/your-data" />;
    }

    const commonProps = {
      renderCategoryList: this.renderCategoryList,
      dateRangeLabel: this.getLabelFromDays(this.props.numberOfDays),
      dateOfRequest: this.formatDate(cleanDateFormat(this.props.dateOfRequest)),
      showConfirmationModal: this.showConfirmationModal
    };


    const downloadPendingContent =
      (checkAMLob() === "vzw" || checkAMLob() === "vzt") && this.props.hasExtension
        ? this.props.pageContent.download_pending_extension
        : this.props.pageContent.download_pending;

    return (
      <Fragment>
        <Container>
          <Div>
            {this.props.downloadReady ? (
              <DownloadReady
                {...commonProps}
                pageContent={this.props.pageContent.download_complete}
                downloadAvailabilityDeadline={this.formatDate(this.props.downloadAvailabilityDeadline)}
                handleDownloadFileClick={this.handleDownloadFileClick}
                resendPasswordClick={this.checkPasswordFlow}
                handleRequestHistoryClick={this.handleRequestHistoryClick}
              />
            ) : (
              <DownloadPending
                {...commonProps}
                pageContent={downloadPendingContent}
                lastExtensionTaken={this.props.lastExtensionTaken}
                downloadAvailabilityDate={this.formatDate(this.props.downloadAvailabilityDate)}
                notificationMethod={this.checkNotificationMethod()}
              />
            )}
          </Div>
        </Container>

        {this.props.error && <Alert alertType="error">{this.props.error}</Alert>}

        {this.props.showModal && this.state.showGuestCancelSuccessModal && (
          <GuestDeleteFileSuccess handleClick={this.handleClick} />
        )}
        {this.props.showModal && this.state.showCancelModal && (
          <CancelRequestModal
            modalContent={this.props.pageContent.cancel_request_modal}
            handleClick={this.handleClick}
            handleCancelClick={() => this.props.handleModalState(false)}
            downloadRequestDate={this.formatDate(cleanDateFormat(this.props.dateOfRequest))}
            loading={this.props.loading}
          />
        )}
        {this.props.showModal && this.state.showDeleteFileModal && (
          <DeleteFileModal
            modalContent={this.props.pageContent.delete_file_modal}
            handleClick={this.handleClick}
            handleCancelClick={() => this.props.handleModalState(false)}
            loading={this.props.loading}
          />
        )}
        {this.props.showModal && this.props.location.state && this.props.location.state.showDownloadModal && (
          <DownloadModal
            uniqueTxnId={this.props.uniqueTxnId}
            fileSize={this.props.fileSize}
            checkForCSRFTokenInfo={this.checkForCSRFTokenInfo}
            modalContent={this.props.pageContent.download_file}
            fileFormat={this.props.fileFormat}
          />
        )}
        {this.state.showMaxPasswordModal ? (
          <MaximumPasswordsReached
            modalContent={this.props.pageContent.maximum_passwords_reached}
            closeModal={() => this.setState({ showMaxPasswordModal: false })}
            historyLinkClick={() => this.props.history.push("request-history")}
            historyLinkRole="link"
          />
        ) : null}
      </Fragment>
    );
  }
}

const mapStateToProps = ({
  modalState,
  downloadAndDelete,
  loadingAndErrorState,
  pageContent,
  verifiedSecurePinDevice,
}) => ({
  showModal: modalState.showModal,
  dateOfRequest: downloadAndDelete.dateOfRequest,
  downloadAvailabilityDate: downloadAndDelete.downloadAvailabilityDate,
  numberOfDays: downloadAndDelete.numberOfDays,
  downloadReady: downloadAndDelete.downloadReady,
  uniqueTxnId: downloadAndDelete.uniqueTxnId,
  fileSize: downloadAndDelete.fileSize,
  mtnList: downloadAndDelete.mtnList,
  encryptedMtn: downloadAndDelete.encryptedMtn,
  requestCategories: downloadAndDelete.requestCategories,
  downloadAvailabilityDeadline: downloadAndDelete.downloadAvailabilityDeadline,
  fileFormat: downloadAndDelete.fileFormat,
  requestedChannel: downloadAndDelete.requestedChannel,
  consentedDate: downloadAndDelete.consentedDate,
  noOfPwdNotificationRemaining: downloadAndDelete.noOfPwdNotificationRemaining,
  hasExtension: downloadAndDelete.hasExtension,
  lastExtensionTaken: downloadAndDelete.lastExtensionTaken,
  emailId: downloadAndDelete.emailId,
  loading: loadingAndErrorState.loading,
  error: loadingAndErrorState.error,
  pageContent,
  verifiedSecurePinDevice,
});

DownloadStatus.propTypes = {
  showModal: PropTypes.bool,
  dateOfRequest: PropTypes.string,
  downloadAvailabilityDate: PropTypes.string,
  numberOfDays: PropTypes.number,
  downloadReady: PropTypes.bool,
  uniqueTxnId: PropTypes.string,
  fileSize: PropTypes.string,
  consentedDate: PropTypes.string,
  mtnList: PropTypes.array,
  encryptedMtn: PropTypes.string,
  requestCategories: PropTypes.array,
  downloadAvailabilityDeadline: PropTypes.string,
  fileFormat: PropTypes.string,
  loading: PropTypes.bool,
  error: PropTypes.string,
  hasExtension: PropTypes.bool,
  lastExtensionTaken: PropTypes.string,
  pageContent: PropTypes.object.isRequired
};

export default connect(
  mapStateToProps,
  {
    handleModalState,
    cancelDownload,
    setA11yContent,
    fetchPageContent,
    checkIfMDNisSMSCapable,
    clearErrors,
    fetchDownloadAndDeleteLanding,
    setBreadcrumbList,
    resendPasswordBegin,
    breadcrumbsLink
  }
)(DownloadStatus);

// const UL = styled.ul`
//   margin: 10px 0;
// `;

const Div = styled.div`
  max-width: 596px;

  ${media.tablet`
    margin: 0 auto;
  `}
`;